// extracted by mini-css-extract-plugin
export var container = "Contact-module--container--dgKEf";
export var area = "Contact-module--area--KOS7I";